/**
 * Snapshots share the launch form's blueprint picker, so a selected snapshot
 * rides through the same string `value` channel as `snapshot:<snp_id>`.
 * Blueprint values stay bare ids, keeping every existing caller untouched.
 *
 * Lives outside the chip component file so non-component modules can encode/
 * decode values without tripping react-refresh's component-only export rule.
 */
export const SNAPSHOT_VALUE_PREFIX = 'snapshot:';

export function snapshotPickerValue(id: string): string {
  return `${SNAPSHOT_VALUE_PREFIX}${id}`;
}

export function snapshotIdFromPickerValue(value: string): string | null {
  return value.startsWith(SNAPSHOT_VALUE_PREFIX) ? value.slice(SNAPSHOT_VALUE_PREFIX.length) : null;
}
